import { columnCountLabel } from 'app/lib/columnCountLabel'

/** "12" when a lane is fully loaded, "12 of 40" while it is not. */
export function LaneCount({ shown, total }: { shown: number; total: number }) {
  return <p className="shrink-0 text-body-xs tabular-nums text-subtle">{columnCountLabel(shown, total)}</p>
}
